export default __webpack_public_path__ + "static/media/departmentvalues.951037d0.png";